import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: {},
  catalog: [],
  testCount: 0,
  commodityCategories: [],
  commodities: [],
  testCategories: []
};

const companyCatalogEditSlice = createSlice({
  name: "companyCatalogEdit",
  initialState,
  reducers: {
    fetchCompanyDetails(state, action) {
      state.loading = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchCatalog(state, action) {
      state.loading = true;
    },
    fetchCatalogSuccess(state, action) {
      state.catalog = action.payload.data.document;
      state.testCount = action.payload.count;
      state.loading = false;
    },
    fetchCatalogFailure(state, action) {
      state.loading = false;
    },
    fetchCommodityCategories(state, action) {
      state.loading = true;
    },
    fetchCommodityCategoriesSuccess(state, action) {
      state.commodityCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityCategoriesFailure(state, action) {
      state.loading = false;
    },
    fetchCommodity(state, action) {
      state.loading = true;
    },
    fetchCommoditySuccess(state, action) {
      state.commodities = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityFailure(state, action) {
      state.loading = false;
    },
    fetchTestCategory(state, action) {
      state.loading = true;
    },
    fetchTestCategorySuccess(state, action) {
      state.testCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchTestCategoryFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyCatalogEditSlice;
